import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';
const ProductionColumns = (props) => {
  const productionColumns: any = [
    {
      name: props.t('Productivity'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('unit_dimension_name'),
      selector: (row) => row.unitDimension?.value,
      sortable: true,
      center: true,
    },
    {
      name: props.t('unit_production_name'),
      selector: (row) => row.unitProduction?.value,
      sortable: true,
      center: true,
    },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={productionColumns} data={props.data} />;
};

export default translate(ProductionColumns);
